import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Menu, Icon } from 'antd'
import { connect } from 'react-redux'
import { get } from 'lodash'
import roles from '../../constants/Roles'

const SubMenu = Menu.SubMenu
// const MenuItemGroup = Menu.ItemGroup

const JobTitleArea = styled.div`
  background-color: transparent;
  padding-top: 2px;
  padding-left: 5px;
  padding-right: 5px;
`

class TitleArea extends PureComponent {
  canSeeFinancialReports = () => {
    const { userRoles } = this.props
    return userRoles.some(
      r => r === roles.CONTROLLER_1 || r === roles.ADMIN || r === roles.CONTROLLER_2
    )
  }
  render() {
    const { currentPage, handleClickMenu } = this.props
    return (
      <div className="dataHeader">
        <JobTitleArea>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/reports">Reports</Link>
                  </li>
                  {currentPage === 'financial/aias-report' && [
                    <li key="1" className="breadcrumb-item">
                      Financial
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      AIAs Report
                    </li>
                  ]}
                  {currentPage === 'financial/active-job-contracts-report' && [
                    <li key="1" className="breadcrumb-item">
                      Financial
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Active Job Contracts
                    </li>
                  ]}
                  {currentPage === 'financial/payment-request-report' && [
                    <li key="1" className="breadcrumb-item">
                      Financial
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Payment Request Report
                    </li>
                  ]}
                  {currentPage === 'financial/invoices-report' && [
                    <li key="1" className="breadcrumb-item">
                      Financial
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Invoices Report
                    </li>
                  ]}
                  {currentPage === 'general/activity-report' && [
                    <li key="1" className="breadcrumb-item">
                      General
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Activity Report
                    </li>
                  ]}
                  {currentPage === 'general/open-items-report' && [
                    <li key="1" className="breadcrumb-item">
                      General
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Open Items Report
                    </li>
                  ]}
                  {currentPage === 'general/purchase-orders-report' && [
                    <li key="1" className="breadcrumb-item">
                      General
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Generate Purchase Orders Report
                    </li>
                  ]}
                  {currentPage === 'general/job-minutes-report' && [
                    <li key="1" className="breadcrumb-item">
                      General
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Job Minutes Report
                    </li>
                  ]}
                  {currentPage === 'financial/maintenance-financials-report' && [
                    <li key="1" className="breadcrumb-item">
                      Financial
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Maintenance Financials
                    </li>
                  ]}
                  {currentPage === 'general/tools-report' && [
                    <li key="1" className="breadcrumb-item">
                      General
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Tools Report
                    </li>
                  ]}
                  {currentPage === 'general/schedule-report' && [
                    <li key="1" className="breadcrumb-item">
                      General
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Schedule Report
                    </li>
                  ]}
                  {currentPage === 'maintenance-dob/stop-calls-report' && [
                    <li key="1" className="breadcrumb-item">
                      Maintenance/DOB
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Stop Calls Report
                    </li>
                  ]}
                  {currentPage === 'maintenance-dob/violations-report' && [
                    <li key="1" className="breadcrumb-item">
                      Maintenance/DOB
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Violations Report
                    </li>
                  ]}
                  {currentPage === 'maintenance-dob/targeted-monthly-visits-report' && [
                    <li key="1" className="breadcrumb-item">
                      Maintenance/DOB
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Targeted Monthly Visits Report
                    </li>
                  ]}
                  {currentPage === 'maintenance-dob/application-schedules-report' && [
                    <li key="1" className="breadcrumb-item">
                      Maintenance/DOB
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Applications/Permits Schedules Report
                    </li>
                  ]}
                  {currentPage === 'maintenance-dob/tickets-report' && [
                    <li key="1" className="breadcrumb-item">
                      Maintenance/DOB
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Tickets Report
                    </li>
                  ]}
                  {currentPage === 'maintenance-dob/maintenance-schedules-report' && [
                    <li key="1" className="breadcrumb-item">
                      Maintenance/DOB
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Maintenance Schedules Report
                    </li>
                  ]}
                  {currentPage === 'leads/leads' && [
                    <li key="1" className="breadcrumb-item">
                      Leads
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Leads Report
                    </li>
                  ]}
                  {currentPage === 'leads/proposals-sent' && [
                    <li key="1" className="breadcrumb-item">
                      Leads
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Proposals Sent Report
                    </li>
                  ]}
                  {currentPage === 'leads/contracts-sent' && [
                    <li key="1" className="breadcrumb-item">
                      Leads
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Contracts Sent Report
                    </li>
                  ]}
                  {currentPage === 'jobs/jobs' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Jobs Report
                    </li>
                  ]}
                  {currentPage === 'jobs/drawings' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Drawings Report
                    </li>
                  ]}
                  {currentPage === 'jobs/confirmed-shipment-dates' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Confirmed Shipment Dates Report
                    </li>
                  ]}
                  {currentPage === 'jobs/transmittals' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Transmittals Report
                    </li>
                  ]}
                  {currentPage === 'jobs/rfis' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      RFIs Report
                    </li>
                  ]}
                  {currentPage === 'jobs/site-work-schedules' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Site Work Schedules Report
                    </li>
                  ]}
                  {currentPage === 'jobs/manufacturing-schedule' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Manufacturing Schedules Report
                    </li>
                  ]}
                  {currentPage === 'jobs/drawing-schedules' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Drawing Schedules Report
                    </li>
                  ]}
                  {currentPage === 'jobs/change-orders' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Change Orders Report
                    </li>
                  ]}
                  {currentPage === 'jobs/financial-schedules' && [
                    <li key="1" className="breadcrumb-item">
                      Jobs
                    </li>,
                    <li key="2" className="breadcrumb-item">
                      Financial Schedules Report
                    </li>
                  ]}
                </ol>
              </nav>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 jobTitle">
              <h2>Reports</h2>
            </div>
          </div>
        </JobTitleArea>
        <Menu onClick={handleClickMenu} selectedKeys={[currentPage]} mode={'horizontal'}>
          <SubMenu
            title={
              <span className="submenu-title-wrapper">
                <Icon type="setting" />
                General
              </span>
            }
          >
            <Menu.Item key="general/activity-report">Activity Report</Menu.Item>
            <Menu.Item key="general/open-items-report">Open Items Report</Menu.Item>
            <Menu.Item key="general/purchase-orders-report">
              Generate Purchase Orders Report
            </Menu.Item>
            <Menu.Item key="general/schedule-report">Schedule Report</Menu.Item>
            <Menu.Item key="general/job-minutes-report">Job Minutes Report</Menu.Item>
            <Menu.Item key="general/tools-report">Tools Report</Menu.Item>
          </SubMenu>
          {this.canSeeFinancialReports() && (
            <SubMenu
              title={
                <span className="submenu-title-wrapper">
                  <Icon type="setting" />
                  Financial
                </span>
              }
            >
              <Menu.Item key="financial/aias-report">AIAs Report</Menu.Item>
              <Menu.Item key="financial/active-job-contracts-report">
                Active Job Contract Report
              </Menu.Item>
              <Menu.Item key="financial/payment-request-report">Payment Request Report</Menu.Item>
              <Menu.Item key="financial/invoices-report">Invoices Report</Menu.Item>
              <Menu.Item key="financial/maintenance-financials-report">
                Maintenance Financials
              </Menu.Item>
            </SubMenu>
          )}
          <SubMenu
            title={
              <span className="submenu-title-wrapper">
                <Icon type="setting" />
                Leads
              </span>
            }
          >
            <Menu.Item key="leads/leads">Leads Report</Menu.Item>
            <Menu.Item key="leads/proposals-sent">Proposals Sent Report</Menu.Item>
            <Menu.Item key="leads/contracts-sent">Contracts Sent Report</Menu.Item>
          </SubMenu>
          <SubMenu
            title={
              <span className="submenu-title-wrapper">
                <Icon type="setting" />
                Jobs
              </span>
            }
          >
            <Menu.Item key="jobs/jobs">Jobs Report</Menu.Item>
            <Menu.Item key="jobs/drawings">Drawings Report</Menu.Item>
            <Menu.Item key="jobs/confirmed-shipment-dates">
              Confirmed Shipment Dates Report
            </Menu.Item>
            <Menu.Item key="jobs/transmittals">Transmittals Report</Menu.Item>
            <Menu.Item key="jobs/rfis">RFIs Report</Menu.Item>
            <Menu.Item key="jobs/site-work-schedules">Site Work Schedules Report</Menu.Item>
            <Menu.Item key="jobs/manufacturing-schedule">Manufacturing Schedules Report</Menu.Item>
            <Menu.Item key="jobs/drawing-schedules">Drawing Schedules Report</Menu.Item>
            <Menu.Item key="jobs/change-orders">Change Orders Report</Menu.Item>
            <Menu.Item key="jobs/financial-schedules">Financial Schedules Report</Menu.Item>
          </SubMenu>
          <SubMenu
            title={
              <span className="submenu-title-wrapper">
                <Icon type="setting" />
                Maintenance/DOB
              </span>
            }
          >
            <Menu.Item key="maintenance-dob/stop-calls-report">Stop Calls Report</Menu.Item>
            <Menu.Item key="maintenance-dob/violations-report">Violations Report</Menu.Item>
            <Menu.Item key="maintenance-dob/targeted-monthly-visits-report">
              Targeted Monthly Visits Report
            </Menu.Item>
            <Menu.Item key="maintenance-dob/application-schedules-report">
              Applications/Permits Schedules Report
            </Menu.Item>
            <Menu.Item key="maintenance-dob/tickets-report">Tickets Report</Menu.Item>
            <Menu.Item key="maintenance-dob/maintenance-schedules-report">
              Maintenance Schedules Report
            </Menu.Item>
          </SubMenu>
        </Menu>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  userRoles: get(state, 'authentication.user.roles', [])
})

export default connect(mapStateToProps)(TitleArea)



// WEBPACK FOOTER //
// ./src/components/reports/DataHeader.js